import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { ReatiAddComponent } from './reati-add.component';
import { SezioneReati } from 'src/app/common/models/sezioni/sezione-reati';


declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: 'div [reato-mod-add]',
  templateUrl: 'reato-mod-add.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ReatoModAdd {
  @Output() onReturn: EventEmitter<SezioneReati> = new EventEmitter<SezioneReati>();
  @ViewChild('formReatoAdd') formReato: ReatiAddComponent;

  inizializza(idSezione: string, fascicolo: FascicoloFull, urlInsert: string, urlReadSezioneAltreParti: string, urlReadSezioneControparti: string) {
    this.formReato.inizializza(idSezione, fascicolo, urlInsert, urlReadSezioneAltreParti, urlReadSezioneControparti);
    openModal('modaladdReato');
  }

  createForm() {
    this.formReato.createForm();
  }

  manageModal(SezioneReati: SezioneReati) {
      closeModal('modaladdReato');
      this.onReturn.emit(SezioneReati);
  }
}
